import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { createHead } from '@vueuse/head'
import ArcoVue from '@arco-design/web-vue'
import '@arco-design/web-vue/dist/arco.css'
import router from './router'
import i18n from './locales'
import App from './App.vue'
import AOS from 'aos'
import 'aos/dist/aos.css'

// 原版CSS已经在index.html中引入，这里只需要Vue 3的补充样式
import './styles/vue3-additions.scss'

const app = createApp(App)
const head = createHead()
const pinia = createPinia()

// 使用插件
app.use(head)
app.use(pinia)
app.use(router)
app.use(ArcoVue)

// 添加错误处理
try {
  app.use(i18n)
} catch (error) {
  console.error('i18n initialization error:', error)
}

// 全局错误处理
app.config.errorHandler = (err, instance, info) => {
  console.error('Vue error:', err, info)
  // 在生产环境下不要让错误阻止应用运行
  if (import.meta.env.PROD && err.message && err.message.includes('Invalid linked format')) {
    console.warn('Ignoring i18n format error in production')
    return
  }
}

// 挂载应用
app.mount('#app')

// 初始化 AOS 动画库
AOS.init({
  duration: 300,
  once: true
})